export default __webpack_public_path__ + "static/media/semipermanentbarrier.f92c7702.png";